import { useEffect, useRef } from "react";
import parseJwt from "./parseJWT";
import api from "./axiosInstance";

function useTracking(user) {
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const startTracking = () => {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          sendTrackingData({ username: user.username });
        }, 60 * 1000);
      }
    };

    const stopTracking = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        startTracking();
      } else {
        timeoutRef.current = setTimeout(() => {
          stopTracking();
        }, 30 * 1000);
      }
    };
    if (
      user?.username &&
      user?.role === "subject" &&
      user?.randomization != null
    ) {
      if (document.visibilityState === "visible") {
        startTracking();
      }
      document.addEventListener("visibilitychange", handleVisibilityChange);
    }

    return () => {
      stopTracking();
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [user]);
}

const sendTrackingData = async ({ timeSpent = 1, username }) => {
  if (localStorage.getItem("idToken") && username) {
    try {
      const decoded = parseJwt(localStorage.getItem("idToken"));
      const jti = decoded["jti"];
      const todaysDate = new Date().toISOString().split("T")[0];

      await api.post("/user/tracking", {
        jti: jti,
        username: username,
        date: todaysDate,
        timeSpentMinutes: timeSpent,
      });
    } catch (error) {
      console.error("Error sending session data: ", error);
    }
  }
};

export default useTracking;
